<template>
    <div class="card">
    <slot>

    </slot>
    </div>
</template>

<style lang="scss" scoped>
    .card{
        margin:auto;
        margin-top:1rem;
        height:fit-content;
        margin-bottom:1rem;
        background-color:rgb(228, 228, 228);
        color:rgb(24, 24, 24);
        box-shadow:1px 3px 8px rgba(0, 0, 0, 0.315);
        border-radius:5px;
        width:90%;
        height:100%;
        padding:1rem;
        position:relative;
    }

</style>